import { render, staticRenderFns } from "./myDoc.vue?vue&type=template&id=8db5b8c2&scoped=true"
import script from "./myDoc.vue?vue&type=script&lang=js"
export * from "./myDoc.vue?vue&type=script&lang=js"
import style0 from "./myDoc.vue?vue&type=style&index=0&id=8db5b8c2&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db5b8c2",
  null
  
)

export default component.exports